import YFormCheckbox from './Checkbox';

export { YFormCheckbox };
export default YFormCheckbox;
